import styled from '@emotion/styled'

interface ScheduleStyleProps {
    isFullSize: boolean
}

export const StyledScheduleWrap = styled('div')<ScheduleStyleProps>(
    ({ theme, isFullSize }) => ({
        height: '100%',
        background: 'white',
    }),
)
